import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthStoreState {
  isJwtLoading: boolean;
  allow_marketing_notifications: boolean;
}

const initialState = {
  isJwtLoading: true,
  allow_marketing_notifications: false,
} as AuthStoreState;

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    SET_IS_JWT_LOADING(
      state,
      action: PayloadAction<AuthStoreState['isJwtLoading']>
    ) {
      state.isJwtLoading = action.payload;
    },
    SET_ALLOW_MARKETING_NOTIFICATIONS(state, action: { payload: boolean }) {
      state.allow_marketing_notifications = action.payload;
    },
  },
});

export default authSlice.reducer;
export const { SET_IS_JWT_LOADING, SET_ALLOW_MARKETING_NOTIFICATIONS } =
  authSlice.actions;
